import { useContext } from 'react';

import { BookingType } from '../../types/booking';

import { BookingStorageContext } from './index';

const useBookingStorage = (): {
	state: BookingType[];
	dispatchSetAction: (payload: BookingType[]) => void;
	dispatchUpdateAction: (payload: BookingType) => void;
	dispatchDeleteAction: (guid: string) => void;
} => {
	const { state, dispatch } = useContext(BookingStorageContext);

	const dispatchSetAction = (payload: BookingType[]) => {
		setTimeout(() => {
			dispatch({ type: 'set', payload });
		}, 0);
	};

	const dispatchUpdateAction = (payload: BookingType) => {
		setTimeout(() => {
			dispatch({ type: 'update', payload });
		}, 0);
	};

	const dispatchDeleteAction = (guid: string) => {
		setTimeout(() => {
			dispatch({ type: 'delete', payload: guid });
		}, 0);
	};

	return { state, dispatchSetAction, dispatchUpdateAction, dispatchDeleteAction };
};

export default useBookingStorage;
